var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discount-flag-checkbox"},[_c('CDiscountFlashSaleInput',{attrs:{"input":_vm.flashSale}}),_c('CDiscountSalesInput',{attrs:{"input":_vm.sales}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }